import { drainedCohesion, drainedSoilPermeability, effectivePorosity, frictionAngle, remodeledSoilPermeability, saturatedUnitWeight, undrainedCohesion, unitWeight } from "../conversion/soil";
import { EUnitOfMeasure } from "../shared/enum";

export default {
    [frictionAngle]: {
        min: {
            unitOfMeasure: {
                [EUnitOfMeasure.Metric]: 10,
                [EUnitOfMeasure.Imperial]: 10,
            },
        },
        max: {
            unitOfMeasure: {
                [EUnitOfMeasure.Metric]: 60,
                [EUnitOfMeasure.Imperial]: 60,
            },
        },
    },
    [drainedCohesion]: {
        min: {
            unitOfMeasure: {
                [EUnitOfMeasure.Metric]: 0,
                [EUnitOfMeasure.Imperial]: 0,
            },
        },
        max: {
            unitOfMeasure: {
                [EUnitOfMeasure.Metric]: undefined,
                [EUnitOfMeasure.Imperial]: undefined,
            },
        },
    },
    [undrainedCohesion]: {
        min: {
            unitOfMeasure: {
                [EUnitOfMeasure.Metric]: 0,
                [EUnitOfMeasure.Imperial]: 0,
            },
        },
        max: {
            unitOfMeasure: {
                [EUnitOfMeasure.Metric]: undefined,
                [EUnitOfMeasure.Imperial]: undefined,
            },
        },
    },
    [drainedSoilPermeability]: {
        min: {
            unitOfMeasure: {
                [EUnitOfMeasure.Metric]: 0,
                [EUnitOfMeasure.Imperial]: 0,
            },
        },
        max: {
            unitOfMeasure: {
                [EUnitOfMeasure.Metric]: undefined,
                [EUnitOfMeasure.Imperial]: undefined,
            },
        },
    },
    [remodeledSoilPermeability]: {
        min: {
            unitOfMeasure: {
                [EUnitOfMeasure.Metric]: 0,
                [EUnitOfMeasure.Imperial]: 0,
            },
        },
        max: {
            unitOfMeasure: {
                [EUnitOfMeasure.Metric]: undefined,
                [EUnitOfMeasure.Imperial]: undefined,
            },
        },
    },
    [unitWeight]: {
        min: {
            unitOfMeasure: {
                [EUnitOfMeasure.Metric]: 10,
                [EUnitOfMeasure.Imperial]: 32.8,
            },
        },
        max: {
            unitOfMeasure: {
                [EUnitOfMeasure.Metric]: 50,
                [EUnitOfMeasure.Imperial]: 164,
            },
        },
    },
    [saturatedUnitWeight]: {
        min: {
            unitOfMeasure: {
                [EUnitOfMeasure.Metric]: 10,
                [EUnitOfMeasure.Imperial]: 32.8,
            },
        },
        max: {
            unitOfMeasure: {
                [EUnitOfMeasure.Metric]: 50,
                [EUnitOfMeasure.Imperial]: 164,
            },
        },
    },
    [effectivePorosity]: {
        min: {
            unitOfMeasure: {
                [EUnitOfMeasure.Metric]: 0,
                [EUnitOfMeasure.Imperial]: 0,
            },
        },
        max: {
            unitOfMeasure: {
                [EUnitOfMeasure.Metric]: 1,
                [EUnitOfMeasure.Imperial]: 3.2,
            },
        },
    },
}